export function escape (string) {
  return `"${string.replace(/"/g, '\\"')}"`
}



// WEBPACK FOOTER //
// ./src/server/helpers/leverade-api.js